const $popup = document.querySelector("#popup");

window.setTimeout(() => {
  if ($popup) {
    $popup.classList.add("active");
  }
}, 3000);

// elements
const $datePickerInput = document.querySelector("#date-picker-input"),
  $modal = document.querySelector("#modal"),
  $overlay = document.querySelector("#overlay"),
  $message = document.querySelector("#message-date-picker"),
  $deliveryCheckbox = document.querySelector("#CDMX-delivery"),
  $saveBtn = document.querySelector("#save-btn"),
  $closePopupBtn = document.querySelector("#close-popup-btn"),
  $pickedDateText = document.querySelector("#picked-date-text");

// set checkbox to false by default
if ($deliveryCheckbox) {
  $deliveryCheckbox.checked = false;
}

// times and dates
const today = new Date(),
  year = today.getFullYear(),
  dayOfTheWeek = today.getDay(),
  currentHour = today.getHours(),
  currentMinute = today.getMinutes(),
  isFriday = dayOfTheWeek === 5,
  isWeekend = dayOfTheWeek === 0 || dayOfTheWeek === 6,
  isBusinessDay = dayOfTheWeek > 0 && dayOfTheWeek < 6,
  isBefore12PM = currentHour < 12,
  isAfter12PM = currentHour > 12 || (currentHour === 12 && currentMinute >= 0);

let month = String(today.getMonth() + 1);
month = month.length === 1 ? `0${month}` : month;

// this calculate the shipping date depending of current Hour and current Date
// if it's business day before 12pm: shipping date today
// if it's business day after 12pm: shipping available until next day
// if it's friday before 12pm: shipping available from Saturday
// if it's friday after 12pm: shipping available until on Monday
// if it's weekend: shipping available until on Monday
let day = String(
  isWeekend
    ? dayOfTheWeek === 0
      ? today.getDate() + 1
      : today.getDate() + 2 // next Monday if it's weekend
    : isFriday && isAfter12PM
    ? today.getDate() + 3 // next Monday if it's Friday after 12 PM
    : (isFriday && isBefore12PM) || (isBusinessDay && isAfter12PM)
    ? today.getDate() + 1 // tomorrow if it's Friday before 12 PM and if it's a business day and after 12 PM
    : today.getDate() // today if it's a business day and before 12 PM
);
day = day.length === 1 ? `0${day}` : day;

// set the minimum date for shipping
const minDate = `${year}/${month}/${day}`;

flatpickr($datePickerInput, {
  minDate: minDate,
  dateFormat: "d/m/Y",
  disableMobile: true,
  appendTo: document.getElementById("date-picker"),
});

const message =
  isFriday && currentHour >= 12
    ? "Envío Lunes"
    : isFriday && currentHour < 12
    ? "Envío Sábado o Domingo"
    : isBusinessDay && currentHour < 12
    ? "✅ Envío de mismo día"
    : dayOfTheWeek === 0 || dayOfTheWeek === 6 || currentHour >= 12
    ? "Envío al siguiente día hábil"
    : "";

// Events
if ($deliveryCheckbox) {
  $deliveryCheckbox.onchange = function (e) {
    if (e.target.checked) {
      $modal.classList.add("active");
      $overlay.classList.add("active");
      $message.textContent = message;
      document.body.style.overflow = 'hidden';
    }

    if (!e.target.checked) {
      saveShippingDate("");
      $modal.classList.remove("active");
      $overlay.classList.remove("active");
      document.body.style.overflow = 'unset';
    }
  };
}

if ($saveBtn) {
  $saveBtn.addEventListener("click", (e) => {
    if ($datePickerInput.value.trim() === "") return;

    saveShippingDate($datePickerInput.value.trim());

    $modal.classList.remove("active");
    $overlay.classList.remove("active");
    document.body.style.overflow = 'unset';
  });
}

if ($closePopupBtn) {
  $closePopupBtn.addEventListener("click", () => {
    $popup.classList.remove("active");
    $modal.classList.remove("active");
    $overlay.classList.remove("active");
    document.body.style.overflow = 'unset';
  });
}

$datePickerInput.onchange = function (e) {
  const datePicked = e.target.value;
  const dateFormated = datePicked.split("-").reverse().join("/");
  const $flatpickrCalendar = document.querySelector(".flatpickr-calendar");

  $pickedDateText.textContent =
    datePicked.trim() !== "" ? `Entrega el ${dateFormated}` : "";

  if ($pickedDateText.textContent !== "") {
    $flatpickrCalendar.classList.add("new-top");
  }
};

const saveShippingDate = (dateAsString) => {
  // this save the shipping date as cart attribute in order
  if (dateAsString === undefined) return;
  const $fechaEnvioInput = document.querySelector("#fecha-envio-cmdx");

  if (!$fechaEnvioInput) return;

  if (!$deliveryCheckbox.checked) {
    console.info("La fecha de entrega fue seleccionada");
    $fechaEnvioInput.setAttribute(
      "value",
      "La fecha de entrega (CDMX) no fue seleccionada"
    );
    return;
  }

  $fechaEnvioInput.setAttribute(
    "value",
    "Fecha de entrega (CMDX): " + dateAsString.split("-").reverse().join("/")
  );
};
